/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_View_BarInputs */

const en_admin_ai_chat_view_bar = /** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bar`)
};

const de_admin_ai_chat_view_bar = /** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balken`)
};

const es_admin_ai_chat_view_bar = /** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barras`)
};

const fr_admin_ai_chat_view_bar = /** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barres`)
};

const nl_admin_ai_chat_view_bar = /** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staaf`)
};

/** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */
const it_admin_ai_chat_view_bar = en_admin_ai_chat_view_bar;

/** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_view_bar = en_admin_ai_chat_view_bar;

/** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */
const pl_admin_ai_chat_view_bar = en_admin_ai_chat_view_bar;

/** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */
const hu_admin_ai_chat_view_bar = en_admin_ai_chat_view_bar;

/** @type {(inputs: Admin_Ai_Chat_View_BarInputs) => LocalizedString} */
const ro_admin_ai_chat_view_bar = en_admin_ai_chat_view_bar;

/**
* | output |
* | --- |
* | "Bar" |
*
* @param {Admin_Ai_Chat_View_BarInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_view_bar = /** @type {((inputs?: Admin_Ai_Chat_View_BarInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_View_BarInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_view_bar(inputs)
	if (locale === "de") return de_admin_ai_chat_view_bar(inputs)
	if (locale === "es") return es_admin_ai_chat_view_bar(inputs)
	if (locale === "fr") return fr_admin_ai_chat_view_bar(inputs)
	if (locale === "nl") return nl_admin_ai_chat_view_bar(inputs)
	if (locale === "it") return it_admin_ai_chat_view_bar(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_view_bar(inputs)
	if (locale === "pl") return pl_admin_ai_chat_view_bar(inputs)
	if (locale === "hu") return hu_admin_ai_chat_view_bar(inputs)
	return ro_admin_ai_chat_view_bar(inputs)
});
export { admin_ai_chat_view_bar as "admin.ai_chat.view_bar" }